import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'
import { isNativeApp } from './platform.js'

// El backend redirige el flujo de OAuth (login Google, connect Google Calendar)
// a `com.gior.gestor://<path>?<query>` en vez de una URL https cuando la
// request se originó en la app nativa (ver Login.vue / useGoogleCalendar.js).
// Reescribimos esa URL a una navegación normal del router para reusar
// AuthCallback.vue / GoogleCalendarCallback.vue tal cual funcionan en web.
export function initNativeDeepLinks(router) {
  if (!isNativeApp()) return

  App.addListener('appUrlOpen', ({ url }) => {
    Browser.close().catch(() => {})

    try {
      const parsed = new URL(url)
      const path = `/${parsed.host}${parsed.pathname}`
      const query = Object.fromEntries(parsed.searchParams.entries())
      router.push({ path, query })
    } catch (err) {
      console.error('[nativeDeepLinks] URL de retorno inválida:', url, err)
    }
  })
}
